<template>
  <div id="app">
    <template v-if="preloadingDone">
      <asideMenu />
      <routerViewBox />
      <v-navbar />
    </template>
    <template v-else>
      <loading />
    </template>
  </div>
</template>

<script>
import loading from "@/components/loading/index.vue";
import asideMenu from "@/components/aside-menu/index.vue";
import routerViewBox from "@/components/router-view-box/index.vue";
import { mapState } from "vuex";
export default {
  components: {
    loading,
    routerViewBox,
    asideMenu,
  },
  computed: {
    ...mapState("global", ["preloadingDone"]),
  },
  data() {
    return {};
  },

  created() {},
};
</script>
